
import { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

interface FAQItemProps {
  question: string;
  answer: string;
}

const FAQItem = ({ question, answer }: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger className="flex items-center justify-between w-full text-left bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
        <h3 className="text-lg font-semibold">{question}</h3>
        {isOpen ? (
          <Minus className="h-5 w-5 text-gray-500 flex-shrink-0" />
        ) : (
          <Plus className="h-5 w-5 text-gray-500 flex-shrink-0" />
        )}
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="bg-white px-6 pb-6 pt-2 text-gray-600 rounded-b-lg shadow-sm">
          {answer}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export const FAQ = () => {
  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <FAQItem 
        question="How does Bright Stages work?"
        answer="Bright Stages is an original system designed using research-backed developmental assessments to track a child's progress from birth to age six. Through interactive, stage-based tests, parents and educators can evaluate key areas such as motor skills, language, cognitive development, independence, and social-emotional growth. The results provide personalized insights to monitor progress, celebrate achievements, and support ongoing learning."
      />
      <FAQItem 
        question="Is Bright Stages currently available on the App Store or Google Play?"
        answer="We are currently testing the development of the app for both platforms and expect it to be available in the coming weeks. Once launched, users will be able to log in using their existing website accounts. Stay tuned for updates!"
      />
      <FAQItem 
        question="What makes Bright Stages unique?"
        answer="Unlike passive milestone checklists, Bright Stages offers interactive, stage-based assessments that track development across key growth areas. With personalized progress tracking and expert-informed insights, it provides a dynamic, hands-on approach to supporting each child's unique journey."
      />
      <FAQItem 
        question="Can I track multiple children?"
        answer="Yes, Bright Stages allows you to create and track multiple child profiles, providing personalized assessments and progress insights for each child."
      />
      <FAQItem 
        question="Is my data secure?"
        answer="Yes, we take data security seriously. All data is encrypted and stored securely. We never share your personal information with third parties."
      />
    </div>
  );
};
